import { createApp } from 'vue'
import Dlg from './components/dialog';
import writepane from './components/writepane';
import message from './components/message';

document.addEventListener("turbo:load", () => {
  if (document.getElementById("vm-messaging")) {
    const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    const postWithCsrf = (url) => fetch(url, {
      method: 'POST',
      headers: { 'X-CSRF-Token': csrfToken() }
    })

    const app = createApp({
      name: 'Messenger',
      data() {
        return {
          showDropdown: false,
          options: [],
          dialogs: gon.dialogs,
          initialContacts: [],
          contacts: [],
          messages: [],
          active_dialog_id: null,
          active_e164_phone: null,
          active_dialog_new: false,
          new_contact_selection: '',
          new_contact_id: null,
          new_phone_number: '',
          active_name: '',
          left_tab_class: 'active',
          right_tab_class: ''
        }
      },
      created() {
  
        this.contacts = this.parseContacts(gon.contacts);
        this.initialContacts = this.contacts;
        this.options = this.contacts; // Ensure options are set from contacts
        this.setInitialDialog();
        this.updateChat();
      },
      watch: {
        active_dialog_id: 'updateChat',
      },
      methods: {
        messageRemovedEvent(msg) {
          this.removeLocalMessage(msg)

          if (msg.id) {
            postWithCsrf('/messages/' + msg.id + '/trash')
          }
        },
        // remove from pane, remove from dialogs pane
        removeMessageArrived(msg) {
          if (msg.id) {
            this.removeMessage(msg.id)
          }

          if (msg.dialog_id) {
            this.removeMessageFromDialog(msg.id, msg.dialog_id)
          }
        },
        //local removal: remove from pane (auto from dialogs pane) + check dialog removal
        removeLocalMessage(msg) {
          if (msg.id) {
            this.removeMessage(msg.id)
          }

          if (msg.dialog_id) {
            const d = this.findDialog(msg.dialog_id)

            if (d.messages.length == 0) {
              this.removeDialog(d.id)
            }
          }
        },
        scrollToDialog(id) {
          const list = document.getElementById("left-pane")
          const targetLi = document.getElementById('dialog-' + id)

          list.scrollTop = (targetLi.offsetTop - 218)
        },
        newDialogClicked() {
          this.showDropdown = true;
    
          if (!this.findDialog(-1)) {
            this.dialogs.unshift({id: -1, messages: [], new: true})
          }
          this.active_dialog_id = -1
        },
        flagCurrentDialogClicked() {
          if (confirm('Are you sure you want to flag? Contact and all messages will be deleted and phone number reported.')) {
            const id = this.active_dialog_id
            this.removeDialog(id)
            postWithCsrf('/dialogs/' + id + '/flag')
          }
        },
        deleteCurrentDialogClicked() {
          if (confirm('Are you sure you want to delete the conversation?')) {
            const id = this.active_dialog_id
            this.removeDialog(id)
            postWithCsrf('/dialogs/' + id + '/trash')
          }
        },

        parseContacts: function(contacts) {
          let parsed = []

          for (var k in contacts) {
            const contactData = contacts[k].contact || contacts[k]
            const contactName = contactData.name || contactData.middle_name || contactData.phone || ''
            const contactPhone = contactData.phone || ''

            parsed.push({
              id: contactData.id,
              name: contactName,
              phone: contactPhone,
              value: contactData.id,
              label: contactPhone ? `${contactName} (${contactPhone})` : contactName,
            })
          }

          return parsed
        },
        searchPerformed(search, loading) {
          loading(true)

          this.abortContactSearchIfRunning()

          // AbortController, not the promise: fetch() returns a Promise, which has no .abort().
          // The old code called .abort() on it, so every search after the first threw a
          // TypeError and the picker stopped responding entirely.
          const controller = new AbortController()
          window.contacts_search_controller = controller

          fetch(`/search/im/contacts.json?term=${encodeURIComponent(search)}`, { signal: controller.signal })
            .then(response => response.ok ? response.json() : [])
            .then(data => {
              this.contacts = this.parseContacts(data)
              loading(false)
            })
            .catch(() => {
              loading(false)
            })
        },
        abortContactSearchIfRunning() {
          if (window.contacts_search_controller) {
            window.contacts_search_controller.abort()
            window.contacts_search_controller = null
          }
        },
        setInitialDialog() {
          if (gon.initial) {
            this.active_dialog_id = gon.initial

            this.$nextTick(() => {
              this.scrollToDialog(gon.initial)
            })

            if (history.replaceState) {
              history.replaceState('', 'Messages', '/im')
            }
          }
        },
        updateChat() {
          const ad = this.activeDialog();
          
          if (ad) {
            this.toChatTab();
            this.active_dialog_new = ad.new;
            this.showDropdown = !!this.active_dialog_new;

            if (!this.active_dialog_new) {
              this.new_contact_id = null;
              this.new_phone_number = null;
            }

            this.active_name = ad.name;
            this.active_e164_phone = ad.e164_phone;
            if (this.active_dialog_new || ad.id == -1) {
              this.messages = ad.messages || [];
              this.scrollChatToBottom();
            } else {
              this.loadThread(ad.id);
            }
          }

          // Remove contact selection from select
          if (this.new_contact_selection) {
            this.new_contact_selection = '';  // Clear the selection
          }
        },
        // Fetch the FULL conversation thread (and mark it read) when a dialog is opened. Previously the
        // pane only had the dialog's last message, so threads rendered with a single bubble.
        loadThread(id) {
          fetch('/dialogs/' + id + '/mark_read', { method: 'POST', headers: { 'X-CSRF-Token': csrfToken() } })
            .then(r => r.json())
            .then(data => {
              if (this.active_dialog_id != id) return; // user switched away while loading
              this.messages = data.messages || [];
              const d = this.findDialog(id);
              if (d) { d.messages = this.messages; }
              this.markReadInUI(id);
              this.scrollChatToBottom();
            })
            .catch(() => {});
        },
        // Single entry point for a message arriving via the send response OR a Faye push. Appends to the
        // active thread + the dialog, creates the dialog if new, bumps unread, and floats it to the top.
        messageReceived(data) {
          if (!data) return;
          const msg = data.message;
          const dlg = data.dialog;
          if (!msg) return;
          const dialogId = msg.dialog_id || (dlg && dlg.id);
          if (!dialogId) return;

          let dialog = this.findDialog(dialogId);
          if (!dialog && dlg) {
            dialog = { id: dlg.id, messages: [], new: false, contact_id: dlg.contact_id,
                       name: dlg.name, phone_digits: dlg.phone_digits, e164_phone: dlg.e164_phone,
                       unread_count: 0 };
            this.removeDialog(-1); // drop the temporary "new message" placeholder if present
            this.dialogs.unshift(dialog);
          }
          if (!dialog) return;
          if (!dialog.messages) dialog.messages = [];
          if (!dialog.messages.find(m => m.id == msg.id)) dialog.messages.push(msg);

          const outgoing = msg.sender_type === 'Account';
          if (this.active_dialog_id == dialogId) {
            if (!this.messages.find(m => m.id == msg.id)) this.messages.push(msg);
            this.scrollChatToBottom();
            if (!outgoing) this.markRead(dialogId);
          } else if (!outgoing) {
            dialog.unread_count = (dialog.unread_count || 0) + 1;
          }

          // After sending into a brand-new dialog, switch to the real conversation.
          if (outgoing && (this.active_dialog_id == -1 || this.active_dialog_id == 0)) {
            this.active_dialog_id = dialogId;
          }

          this.moveDialogToTop(dialogId);
        },
        // A send failure (or a later success clearing one) recorded by the Twilio job after the bubble
        // appeared. Apply `send_error` to the bubble in the open thread and to the copy on the dialog,
        // matched by id; the message template shows it under the bubble.
        messageStatusArrived(msg) {
          if (!msg || !msg.id) return;
          const apply = (m) => { if (m) m.send_error = msg.send_error || null; };
          apply(this.messages.find(m => m.id == msg.id));
          const dialog = msg.dialog_id ? this.findDialog(msg.dialog_id) : null;
          if (dialog && dialog.messages) apply(dialog.messages.find(m => m.id == msg.id));
        },
        moveDialogToTop(id) {
          const idx = this.findDialogIndex(id);
          if (idx > 0) {
            const removed = this.dialogs.splice(idx, 1)[0];
            this.dialogs.unshift(removed);
          }
        },
        removeMessage(id) {
          const index = this.findMessageIndex(id)
          
          if (index != -1) {
            this.messages.splice(index, 1)
          }
        },
        removeMessageFromDialog(msg_id, dlg_id) {
          const d = this.findDialog(dlg_id)
          const index = this.findMessageIndexInDialog(msg_id, d)

          if (index != -1) {
            d.messages.splice(index, 1)
          }
        },
        removeDialog(id) {
          const index = this.findDialogIndex(id)
          
          if (index != -1) {
            this.dialogs.splice(index, 1)
          }

          if (this.active_dialog_id == id) {
            this.resetDialog()
          }
        },
        removeDialogByPhoneNumber(phone) {
          const d = this.findDialogByPhoneNumber(phone)
          if (d) {
            this.removeDialog(d.id)
          }
        },
        dialogUpdate(id) {
          if (id !== -1) {
            this.showDropdown = false;
          }
          this.active_dialog_id = id
        },
        findDialog(id) {
          return this.dialogs.find(d => d.id == id)
        },
        findDialogIndex(id) {
          return this.dialogs.findIndex(d => d.id == id)
        },
        //e164 numbers only
        findDialogByPhoneNumber(phone) {
          return this.dialogs.find(d => d.e164_phone == phone)
        },
        findDialogByPhoneDigits(phone_digits) {
          return this.dialogs.find(d => d.phone_digits == phone_digits)
        },
        findDialogByContactId(contact_id) {
          return this.dialogs.find(d => d.contact_id == contact_id)
        },
        findMessageIndex(id) {
          return this.messages.findIndex(m => m.id == id)
        },
        findMessageIndexInDialog(id, d) {
          return d.messages.findIndex(m => m.id == id)
        },
        activeDialog() {
          return this.findDialog(this.active_dialog_id)
        },
        markReadInUI(id) {
          const d = this.findDialog(id)
          
          if (d && d.unread_count > 0) {
            d.unread_count = 0
          }
        },
        markRead(id) {
          this.markReadInUI(id);
          
          if (id != 0) {
            if (!this.active_dialog_new) {
              postWithCsrf('/dialogs/' + id + '/mark_read');
            }
          }
        },
        searchCleared() {
          this.contacts = this.initialContacts;
        },

        updateSelectedContact() {
          // The <select> renders options from `this.options` with :value="contact.value",
          // and `value` IS the contact id (see parseContacts). So the selected v-model value
          // is the contact id directly — DON'T look it up in `this.contacts`, which the search
          // path mutates out from under `this.options` (the find would miss and selection would
          // silently do nothing). The option value is the source of truth.
          const selectedContactId = this.new_contact_selection;

          this.abortContactSearchIfRunning();

          // No contact selected (the "Select a contact" placeholder) — clear and bail.
          if (!selectedContactId) {
            this.new_contact_id = null;
            this.new_phone_number = '';
            return;
          }

          // Reuse an existing conversation for this contact if one is already open.
          const existingDialog = this.findDialogByContactId(selectedContactId);
          if (existingDialog) {
            this.activateExistingDialogFromNewDialog(existingDialog);
            return;
          }

          // Not in the loaded list — but the list only holds the most recently active
          // conversations (MAX_INBOX_DIALOGS), so the contact may still have a long history
          // just outside that window. Ask the server before assuming this is a new thread;
          // otherwise years of messages look deleted.
          fetch(`/dialogs/for_contact?contact_id=${encodeURIComponent(selectedContactId)}`)
            .then(r => r.ok ? r.json() : { dialog: null })
            .then(data => {
              if (this.new_contact_selection && this.new_contact_selection != selectedContactId) return;

              if (data && data.dialog && data.dialog.id) {
                const dialog = {
                  id: data.dialog.id,
                  messages: data.messages || [],
                  new: false,
                  contact_id: data.dialog.contact_id,
                  name: data.dialog.name,
                  phone_digits: data.dialog.phone_digits,
                  e164_phone: data.dialog.e164_phone,
                  unread_count: 0
                };
                if (!this.findDialog(dialog.id)) this.dialogs.unshift(dialog);
                this.activateExistingDialogFromNewDialog(dialog);
                return;
              }

              this.startNewConversationWith(selectedContactId);
            })
            .catch(() => this.startNewConversationWith(selectedContactId));
        },

        // Start a brand-new conversation with this contact. The send path (writepane) reads
        // `new_contact_id` from its hidden input to create the dialog. Clears any typed phone
        // number so the two paths don't conflict.
        startNewConversationWith(contactId) {
          this.new_contact_id = contactId;
          this.new_phone_number = '';
        },

        // Typing a raw phone number starts a conversation with that number directly (the old app
        // allowed this; the contact picker alone didn't). Clears any contact selection so they don't conflict.
        onPhoneTyped() {
          if (this.new_phone_number && String(this.new_phone_number).trim()) {
            this.new_contact_id = null;
            this.new_contact_selection = '';
            this.contacts = this.initialContacts;
          }
        },

        activateExistingDialogFromNewDialog(d) {
          // `d` is a DIALOG object (from findDialogByContactId) — open it by its id.
          // (Was d.label, which exists only on parsed contacts, not dialogs → active_dialog_id
          // became undefined and nothing opened.)
          this.showDropdown = false;
          this.new_contact_id = null;
          this.new_phone_number = '';
          this.new_contact_selection = '';
          this.removeDialog(-1); // drop the temporary "new message" placeholder if present
          this.active_dialog_id = d.id;
          this.updateChat();
          this.$nextTick(() => {
            this.scrollToDialog(d.id);
          })
        },
        scrollChatToBottom() {
          this.$nextTick(() => {
            // The scrollable thread pane is #chatpane (was targeting a non-existent #messages-container,
            // so the view never scrolled to the latest message on open/new message).
            const pane = document.getElementById('chatpane')
            if (pane) {
              pane.scrollTop = pane.scrollHeight
            }
          })
        },
        toDialogsClicked() {
          this.showDropdown = false;
          this.resetDialog()
          this.right_tab_class = ''
          this.left_tab_class = 'active'
        },
        resetDialog() {
          this.active_dialog_id = 0
          this.active_dialog_new = false
          this.messages = []
          this.active_name = ''
        },
        toChatTab() {
          this.left_tab_class = ''
          this.right_tab_class = 'active'
        }
      },
    })
    
    app.component('Dlg', Dlg);
    app.component('message', message);
    app.component('writepane', writepane);

    window.vm_messaging = app.mount('#vm-messaging');
  }
})
